import { render, staticRenderFns } from "./popup_add_edit_comment_gov.vue?vue&type=template&id=700c2186&scoped=true&lang=pug"
import script from "./popup_add_edit_comment_gov.vue?vue&type=script&lang=js"
export * from "./popup_add_edit_comment_gov.vue?vue&type=script&lang=js"
import style0 from "../../assets/koromo_min.css?vue&type=style&index=0&id=700c2186&prod&scoped=true&lang=css&external"
import style1 from "./popup_add_edit_comment_gov.vue.css?vue&type=style&index=1&id=700c2186&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c2186",
  null
  
)

export default component.exports